import React, { useState, useRef, useEffect,forwardRef, useImperativeHandle } from "react";
import "../assets/css/App.css"

const CustomDropdown = forwardRef((props,ref) => {
const { options, selectedd, type } = props;
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState('');
  const dropdownRef = useRef(null);
  const handleSelect = (option) => {
    setSelected(option);
    selectedd(option);
    setOpen(false);
  };

  const rest = () => {
    setSelected('')};

useImperativeHandle(ref, () => ({
    rest,
  }));

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div style={{ width: "100%", position: "relative" }} ref={dropdownRef}>
      {/* Dropdown Box */}
      <div
        onClick={() => setOpen(!open)}
        style={{
          width: "100%",
          height: "48px",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 10px",
          cursor: "pointer",
          color: selected ? "white" : "#e4e4e4ff",
          userSelect: "none",
          fontWeight: "600",
        }}
        className="dropDownHover"
      >
        {selected || type}

        <span style={{ color: "white", fontSize: "14px" }}>
          {open ? "▲" : "▼"}
        </span>
      </div>

      {/* Dropdown Menu */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "48px",
            left: "0",
            width: "100%",
            background: "#111827",
            // border: "1px solid gold",
            borderRadius: "8px",
            zIndex: 99,
            overflow: "hidden",
            fontWeight: "600"
          }}
        >
          {options?.map((opt, index) => (
            <div
              key={index}
              onClick={() => handleSelect(opt)}
              style={{
                padding: "10px",
                color: "white",
                cursor: "pointer",
                transition: "0.2s",
                background: selected === opt ? "#1f2937" : "transparent",
              }}
              onMouseEnter={(e) =>
                (e.target.style.background = "#1f2937")
              }
              onMouseLeave={(e) =>
                (e.target.style.background =
                  selected === opt ? "#1f2937" : "transparent")
              }
            >
              {opt}
            </div>
          ))}
        </div>
      )}
    </div>
  );
})
 export default CustomDropdown;